import moment from 'moment'
import numeral from 'numeral'

export const sales = {
    id: '',
    invoiceNo: '',
    date : moment().format('YYYY-MM-DD'),
    isPpn: false,
    customerId: '',
    customerName: '',
    total: numeral(0).format('0,0.00'),
    grandTotal: numeral(0).format('0,0.00'),
    remark: '',
    createdBy : '',
    updatedBy : '',
    createdAt : moment().format('YYYY-MM-DD'),
    updatedAt : moment().format('YYYY-MM-DD'),
}

export const salesDetail = {
    id: '',
    productId: '',
    productName: '',
    warehouseId: '',
    warehouseName: '',
    qty : 0,
    price : 0,
}